import { dayjs } from '@/utils/dayjsSetup.js';

const DEFAULT_AVAILABILITY_WINDOW = 5;

// Normalizes the API availability into a fixed-size window of consecutive days so the calendar
// components can always assume `windowSize` days. Missing days are padded with empty slots and
// extra days are truncated. The window is anchored on `startDate` (the requested window origin),
// falling back to the earliest returned day when `startDate` is missing or invalid. Slots are
// matched by date, so an unordered response is handled correctly.
export const buildAvailabilityWindow = (availability, startDate, windowSize = DEFAULT_AVAILABILITY_WINDOW) => {
    // Entries without a date are dropped here rather than downstream: both maps below
    // dereference `day.date`, so a null entry would throw before any caller could filter it.
    const days = (Array.isArray(availability) ? availability : []).filter((day) => day?.date);
    const slotsByDate = new Map(days.map((day) => [day.date, day.slots ?? []]));
    const earliestDate = days.map((day) => day.date).sort((a, b) => a.localeCompare(b))[0];
    const baseDate = startDate && dayjs(startDate).isValid() ? startDate : earliestDate;

    const availabilityWindow = [];
    for (let i = 0; i < windowSize; i++) {
        const date = dayjs(baseDate).add(i, 'day').format('YYYY-MM-DD');
        availabilityWindow.push({ date, slots: slotsByDate.get(date) ?? [] });
    }

    return availabilityWindow;
};

export const isTimeSlotInvalid = (errorMessage) => {
    if (!errorMessage) {
        return false;
    }

    const formattedErrorMessage = errorMessage.toLowerCase();

    return formattedErrorMessage.includes('no longer available') || formattedErrorMessage.includes('overlap');
};

export const PVSProvider = {
    DOC_CIRRUS: 'doc-cirrus',
    DATA_CUR: 'data-cur',
};
